import { v4 as uuidv4 } from 'uuid';

export const generateGUID = (): string => uuidv4().toUpperCase();